import { PAGINATION_ITEMS_PER_PAGE, PAGINATION_PAGE } from "src/_Globals/urls";

// I think it could be... "URLPagination" in the end.
export type ApiPagination = Partial<Record<"page" | "itemsPerPage", string>>;

export type ApiPaginationUrlSyncOptions = {
    searchParams?: URLSearchParams;
    paginationDefaults?: ApiPagination;
};
export const useApiPaginationUrlSync = (options?: ApiPaginationUrlSyncOptions) => {
    const { searchParams = new URLSearchParams(), paginationDefaults } = options || {};

    const resultingPagination: ApiPagination = {};

    const pageSearchParam = searchParams.get(PAGINATION_PAGE) ?? paginationDefaults?.page;
    if (pageSearchParam !== null) {
        resultingPagination["page"] = pageSearchParam;
    }

    const itemsPerPageSearchParam = searchParams.get(PAGINATION_ITEMS_PER_PAGE) ?? paginationDefaults?.itemsPerPage;
    if (itemsPerPageSearchParam !== null) {
        resultingPagination["itemsPerPage"] = itemsPerPageSearchParam;
    }

    return {
        pagination: resultingPagination,
    };
};
